
export default {
    getCargo(state) {
        return state.cargo
    },
    getCargos(state) {
        return state.cargos
    },
}